module.exports = __webpack_public_path__ + "img/swiper-20.44481e08.png";